import Onboarding from '../../../../components/onboarding/onboarding.desktop';
import onboardingModule from './onboarding';

export default onboardingModule(Onboarding);
